<template>
    <div class="content-item">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'ContentItem',
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content-item {
        /*padding-top: 10px;*/
        min-height: 300px;
    }
</style>

<style>
    .content-highlight {
        background-color: rgba(176, 196, 133, 0.6);
        padding: 15px;
        border-radius: 3px;
    }

    .content-image {
        width: 100%;
        min-height: 350px;
        background-size: cover;
        background-position: center;
    }
</style>
